import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Scale } from "lucide-react";
import { useTranslation } from "react-i18next";
import { MarketingHeader, MarketingFooter } from "@/components/MarketingLayout";

const TERMS_VERSION = "2026-06-01";

export default function TermsOfService() {
  const { t } = useTranslation();
  const sections = t("terms.sections", { returnObjects: true }) || [];

  return (
    <div className="min-h-screen bg-background" data-testid="terms-page">
      <MarketingHeader />
      <main className="max-w-3xl mx-auto px-5 sm:px-8 py-16">
        <Link to="/" className="inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground mb-8" data-testid="terms-back">
          <ArrowLeft size={15} /> {t("terms.back")}
        </Link>
        <span className="inline-flex items-center gap-1.5 text-xs font-medium uppercase tracking-[0.14em] text-primary">
          <Scale size={14} /> {t("terms.eyebrow")}
        </span>
        <h1 className="text-3xl sm:text-4xl font-semibold tracking-tight leading-[1.3] mt-4">{t("terms.title")}</h1>
        <p className="text-sm text-muted-foreground mt-3">
          {t("terms.intro", { version: TERMS_VERSION })}
        </p>

        <div className="mt-12 space-y-10">
          {sections.map((s) => (
            <section key={s.h}>
              <h2 className="text-lg font-semibold tracking-tight text-foreground">{s.h}</h2>
              <div className="mt-3 space-y-2.5">
                {s.b.map((p) => (
                  <p key={p} className="text-[15px] text-muted-foreground leading-relaxed">{p}</p>
                ))}
              </div>
            </section>
          ))}
        </div>

        <div className="mt-14 card-milled rounded-[0.9rem] p-6 sm:p-7 bg-secondary/30">
          <p className="text-sm font-medium text-foreground">{t("terms.relatedTitle")}</p>
          <p className="text-sm text-muted-foreground mt-1">{t("terms.relatedBody")}</p>
          <Link to="/privacy" className="inline-flex items-center gap-1.5 text-sm font-medium text-primary hover:underline mt-3" data-testid="terms-to-privacy">
            {t("terms.relatedLink")}
          </Link>
        </div>
      </main>
      <MarketingFooter />
    </div>
  );
}
